var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5938 6.75781L14.1758 5.97852L11.7266 1.04297C11.3184 0.189453 10.0566 0.152344 9.61133 1.04297L7.19922 5.97852L1.74414 6.75781C0.779297 6.90625 0.408203 8.09375 1.11328 8.79883L5.00977 12.6211L4.08203 18.002C3.93359 18.9668 4.97266 19.709 5.82617 19.2637L10.6875 16.7031L15.5117 19.2637C16.3652 19.709 17.4043 18.9668 17.2559 18.002L16.3281 12.6211L20.2246 8.79883C20.9297 8.09375 20.5586 6.90625 19.5938 6.75781ZM14.3984 11.9902L15.2891 17.1113L10.6875 14.6992L6.04883 17.1113L6.93945 11.9902L3.19141 8.35352L8.34961 7.61133L10.6875 2.93555L12.9883 7.61133L18.1465 8.35352L14.3984 11.9902Z",
    fill: "#65646A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/Premium.fe60278ae684b82469304a7f938c199a.svg";
export { ForwardRef as ReactComponent };